import { findOptions } from "../../../helpers/StringHelper";

export const mapDocuments = (data, options, project = 'myOwnData', user = {}) => {
  const {
    documentTypes,
    typeOfDocument,
    availability,
    docSources = []
  } = options || {};
  return data.map(doc => {
    const associatedStakeholder = [];
    const associatedLocations = [];
    const stakeholderIds = [];
    let source = findOptions(doc.docSource, docSources || []);
    if (project === 'myOwnData') {
      if (doc.stakeholderId && doc.linking && doc.linking.Stakeholder) {
        source = doc.linking.Stakeholder[doc.stakeholderId].name || '';
      }
    } else if (doc.source && doc.source.name) {
      source = doc.source.name;
    }
    if (doc.associatedStakeholder && Array.isArray(doc.associatedStakeholder)) {
      doc.associatedStakeholder.forEach(d => {
        if (d.stakeholderId && !stakeholderIds.includes(d.stakeholderId)) {
          stakeholderIds.push(d.stakeholderId);
        }
      })
    }
    if (stakeholderIds && doc.linking && doc.linking.Stakeholder) {
      const stakeholders = doc.linking.Stakeholder || {};
      stakeholderIds.forEach(s => {
        if (stakeholders[s]) {
          associatedStakeholder.push(stakeholders[s].name);
        }
       })
    }
    if (doc.associatedLocations && Array.isArray(doc.associatedLocations) && doc.linking && doc.linking.SCL) {
      const locations = doc.linking.SCL; 
      doc.associatedLocations.forEach(l => {
        if (l.locationId && locations[l.locationId]) {
          associatedLocations.push(locations[l.locationId].locationName)
        }
      })
    }
    return {
      id: doc.datastakeId ? doc.datastakeId : '',
      datastakeId: doc.datastakeId ? doc.datastakeId : '',
      type: findOptions(doc.typeOfDocument, documentTypes),
      typeOfDocument: findOptions(doc.type, typeOfDocument),
      link: doc.linkText,
      title: doc.title,
      dbId: doc.id,
      source,
      associatedStakeholder,
      associatedLocations,
      availability: findOptions(doc.availability, availability),
      date: doc.date,
      updatedAt: doc.updatedAt,
      publishedAt: doc.publishedAt,
    };
  })
}

export const getDocumentFilterOptions = (options) => {
  const {
    availability = [],
    docSources = [],
    documentTypes = [],
    typeOfDocument = [],
  } = options || {};

  return {
    type: typeOfDocument,
    typeOfDocument: documentTypes,
    docSource: docSources,
    availability, 
  }
}

export const filtersConfig = {
  title: '',
  datastakeId: '',
};

export const selectFiltersConfig = {
  type: {
    type: 'select',
    label: 'Type',
    placeholder: (t) => `${t('Filter by')} ${t('Type').toLowerCase()}`,
    style: { flex: 1 },
    labelStyle: { flex: 1 },
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
  typeOfDocument: {
    type: 'select',
    label: 'Type of document',
    placeholder: (t) => `${t('Filter by')} ${t('Type of document').toLowerCase()}`,
    style: { flex: 1 },
    labelStyle: { flex: 1 },
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
    show: (data) => data.type !== 'document'
  },  
  availability: {
    type: 'select',
    label: 'Availability',
    placeholder: (t) => `${t('Filter by')} ${t('Availability').toLowerCase()}`,
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
    show: (data) => data.type !== 'picture',
    style: { flex: 1 },
    labelStyle: { flex: 1 },
  },  
  docSource: {
    type: 'select',
    label: 'Source',
    placeholder: (t) => `${t('Filter by')} ${t('Source').toLowerCase()}`,
    style: { flex: 1 },
    labelStyle: { flex: 1 },
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },  
};

export const checkboxConfig = {
  title: 'Title',
  datastakeId: 'ID',
};

export const documentsView = 'documents';
